/**
 * An entry on the review request page for review request changes.
 *
 * This stores state needed for change descriptions, including the status
 * updates on the change.
 *
 * See :js:class:`RB.ReviewRequestPage.StatusUpdatesEntry` for additional model
 * attributes.
 */
RB.ReviewRequestPage.ChangeEntry =
    RB.ReviewRequestPage.StatusUpdatesEntry.extend();
